module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/osago@2x-39a61aa2f74b3876c4d37160227d2a6a.png.webp";